import { render, staticRenderFns } from "./consentements.vue?vue&type=template&id=12900504&"
import script from "./consentements.vue?vue&type=script&lang=js&"
export * from "./consentements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports